<template>
  <div  class="nodata">
    <img src="static/images/D.svg" alt="">
  </div>
</template>

<script>
    export default {
        name: "nodata"
    }
</script>

<style scoped>
  .nodata{
    width: 100%;
    margin-top: .5rem;
    text-align: center;
  }
  .nodata img{
    width: 6.35rem;
    height: 4.05rem;
    display: block;
    margin: 6.95rem auto 0;
  }
</style>



// WEBPACK FOOTER //
// src/view/noData.vue